

(function ($) {
  ///////////////////////////////////////////////////////////////////////////
  //resize elements elements 1.0 
  ///////////////////////////////////////////////////////////////////////////
  //
  //  '.yourClass' is the direct parent of the elements you want to rearrange 
  /////////////////////////////////////////////////////////
  //                                                     //
  //  $('.yourClass').qtyResize({                        //          
  //  });                                                //
  //                                                     //
  /////////////////////////////////////////////////////////
  //

  $.fn.qtyResize = function (options) {

    var settings = $.extend({
      width: "width-medium",
      qty_type: " "
    }, options)



    return this.each(function () {
      var elem_parent = $(this);

      var elem = elem_parent.children('.feature');
      var elem_min_width = parseInt(elem.css('min-width'), 10);
      var number_of_elem = elem.size();
      var elem_parent_width = elem_parent.width();

      elem.last().addClass('qty-last');

      console.log(elem_min_width, elem_parent_width, elem_parent_width/elem_min_width)

      function reorganize() {



        function qty_feature() {
          var qty_fit;
          var qty_row;
          
          if (elem_parent.hasClass('qty-1')) {
            if (settings.width == 'width-x-narrow') {
              qty_fit = elem_parent.outerWidth() / 100;
              if (qty_fit >= 1) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-1');
              }
            } else if (settings.width == 'width-narrow') {
              qty_fit = elem_parent.outerWidth() / 200;
              if (qty_fit >= 1) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-medium') {
              qty_fit = elem_parent.outerWidth() / 300;
              if (qty_fit >= 1) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-wide') {
              qty_fit = elem_parent.outerWidth() / 450;
              if (qty_fit >= 1) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-x-wide') {
              qty_fit = elem_parent.outerWidth() / 650;
              if (qty_fit >= 1) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            }
          } else if (elem_parent.hasClass('qty-2')) {
            if (settings.width == 'width-x-narrow') {
              qty_fit = elem_parent.outerWidth() / 100;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }

            } else if (settings.width == 'width-narrow') {
              qty_fit = elem_parent.outerWidth() / 200;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }

            } else if (settings.width == 'width-medium') {
              qty_fit = elem_parent.outerWidth() / 300;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }

            } else if (settings.width == 'width-wide') {
              qty_fit = elem_parent.outerWidth() / 450;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }

            } else if (settings.width == 'width-x-wide') {
              qty_fit = elem_parent.outerWidth() / 650;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            }
          } else if (elem_parent.hasClass('qty-3')) {
            if (settings.width == 'width-x-narrow') {
              qty_fit = elem_parent.outerWidth() / 100;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }

            } else if (settings.width == 'width-narrow') {
              qty_fit = elem_parent.outerWidth() / 200;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }

            } else if (settings.width == 'width-medium') {
              qty_fit = elem_parent.outerWidth() / 300;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }

            } else if (settings.width == 'width-wide') {
              qty_fit = elem_parent.outerWidth() / 450;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }

            } else if (settings.width == 'width-x-wide') {
              qty_fit = elem_parent.outerWidth() / 650;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }


            }
          } else if (elem_parent.hasClass('qty-4')) {
            if (settings.width == 'width-x-narrow') {
              qty_fit = elem_parent.outerWidth() / 100;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 4) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 4;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }

            } else if (settings.width == 'width-narrow') {
              qty_fit = elem_parent.outerWidth() / 200;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 4) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 4;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-medium') {
              qty_fit = elem_parent.outerWidth() / 300;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 4) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 4;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }

            } else if (settings.width == 'width-wide') {
              qty_fit = elem_parent.outerWidth() / 450;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 4) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 4;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }

            } else if (settings.width == 'width-x-wide') {
              qty_fit = elem_parent.outerWidth() / 650;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 4) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 4;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }


            }
          } else if (elem_parent.hasClass('qty-5') && settings.qty_type == 'b-qty') {
            if (settings.width == 'width-x-narrow') {
              qty_fit = elem_parent.outerWidth() / 100;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 5) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-narrow') {
              qty_fit = elem_parent.outerWidth() / 200;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 5) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-medium') {
              qty_fit = elem_parent.outerWidth() / 300;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 5) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-wide') {
              qty_fit = elem_parent.outerWidth() / 450;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 5) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-x-wide') {
              qty_fit = elem_parent.outerWidth() / 650;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 5) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            }
          } else if (elem_parent.hasClass('qty-5') && settings.qty_type == 'c-qty') {
            if (settings.width == 'width-x-narrow') {
              qty_fit = elem_parent.outerWidth() / 100;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 3) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-narrow') {
              qty_fit = elem_parent.outerWidth() / 200;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 3) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-medium') {
              qty_fit = elem_parent.outerWidth() / 300;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 3) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-wide') {
              qty_fit = elem_parent.outerWidth() / 450;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 3) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-x-wide') {
              qty_fit = elem_parent.outerWidth() / 650;

              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 3) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            }
          } else if (elem_parent.hasClass('qty-5')) {
            if (settings.width == 'width-x-narrow') {
              qty_fit = elem_parent.outerWidth() / 100;
              if (qty_fit < 5) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-narrow') {
              qty_fit = elem_parent.outerWidth() / 200;
              if (qty_fit < 5) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-medium') {
              qty_fit = elem_parent.outerWidth() / 300;
              if (qty_fit < 5) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-wide') {
              qty_fit = elem_parent.outerWidth() / 450;
              if (qty_fit < 5) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-x-wide') {
              qty_fit = elem_parent.outerWidth() / 650;
              if (qty_fit < 5) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            }
          } else if (elem_parent.hasClass('qty-6')) {
            if (settings.width == 'width-x-narrow') {
              qty_fit = elem_parent.outerWidth() / 100;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 3) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 6) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 6;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-narrow') {
              qty_fit = elem_parent.outerWidth() / 200;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 3) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 6) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 6;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-medium') {
              qty_fit = elem_parent.outerWidth() / 300;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 3) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 6) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 6;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-wide') {
              qty_fit = elem_parent.outerWidth() / 450;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 3) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 6) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 6;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-x-wide') {
              qty_fit = elem_parent.outerWidth() / 650;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 3) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 6) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 6;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            }
          } else if (elem_parent.hasClass('qty-7') && settings.qty_type == 'b-qty') {
            if (settings.width == 'width-x-narrow') {
              qty_fit = elem_parent.outerWidth() / 100;
              if (qty_fit < 4) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 7) {
                qty_row = 4;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 4;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-narrow') {
              qty_fit = elem_parent.outerWidth() / 200;
              if (qty_fit < 4) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 7) {
                qty_row = 4;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 4;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-medium') {
              qty_fit = elem_parent.outerWidth() / 300;
              if (qty_fit < 4) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 7) {
                qty_row = 4;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 4;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-wide') {
              qty_fit = elem_parent.outerWidth() / 450;
              if (qty_fit < 4) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 7) {
                qty_row = 4;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 4;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-x-wide') {
              qty_fit = elem_parent.outerWidth() / 650;
              if (qty_fit < 4) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 7) {
                qty_row = 4;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 4;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            }
          } else if (elem_parent.hasClass('qty-7') && settings.qty_type == 'c-qty') {
            if (settings.width == 'width-x-narrow') {
              qty_fit = elem_parent.outerWidth() / 100;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 7) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 7;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-narrow') {
              qty_fit = elem_parent.outerWidth() / 200;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 7) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 7;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-medium') {
              qty_fit = elem_parent.outerWidth() / 300;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 7) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 7;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-wide') {
              qty_fit = elem_parent.outerWidth() / 450;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 7) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 7;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-x-wide') {
              qty_fit = elem_parent.outerWidth() / 650;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 7) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 7;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }

            }
          } else if (elem_parent.hasClass('qty-7')) {
            if (settings.width == 'width-x-narrow') {
              qty_fit = elem_parent.outerWidth() / 100;
              if (qty_fit < 7) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 7;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-narrow') {
              qty_fit = elem_parent.outerWidth() / 200;
              if (qty_fit < 7) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 7;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-medium') {
              qty_fit = elem_parent.outerWidth() / 300;
              if (qty_fit < 7) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 7;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-wide') {
              qty_fit = elem_parent.outerWidth() / 450;
              if (qty_fit < 7) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 7;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-x-wide') {
              qty_fit = elem_parent.outerWidth() / 650;
              if (qty_fit < 7) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 7;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            }
          } else if (elem_parent.hasClass('qty-8')) {
            if (settings.width == 'width-x-narrow') {
              qty_fit = elem_parent.outerWidth() / 100;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 4) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 8) {
                qty_row = 4;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 8;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-narrow') {
              qty_fit = elem_parent.outerWidth() / 200;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 4) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 8) {
                qty_row = 4;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 8;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-medium') {
              qty_fit = elem_parent.outerWidth() / 300;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 4) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 8) {
                qty_row = 4;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 8;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-wide') {
              qty_fit = elem_parent.outerWidth() / 450;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 4) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 8) {
                qty_row = 4;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 8;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-x-wide') {
              qty_fit = elem_parent.outerWidth() / 650;
              if (qty_fit < 2) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 4) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 8) {
                qty_row = 4;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 8;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            }
          } else if (elem_parent.hasClass('qty-9') && settings.qty_type == 'b-qty') {
            if (settings.width == 'width-x-narrow') {
              qty_fit = elem_parent.outerWidth() / 100;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 5) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 9) {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 9;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-narrow') {
              qty_fit = elem_parent.outerWidth() / 200;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 5) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 9) {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 9;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-medium') {
              qty_fit = elem_parent.outerWidth() / 300;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 5) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 9) {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 9;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-wide') {
              qty_fit = elem_parent.outerWidth() / 450;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 5) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 9) {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 9;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-x-wide') {
              qty_fit = elem_parent.outerWidth() / 650;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 5) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 9) {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 9;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }

            }
          } else if (elem_parent.hasClass('qty-9')) {
            if (settings.width == 'width-x-narrow') {
              qty_fit = elem_parent.outerWidth() / 100;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 9) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 9;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-narrow') {
              qty_fit = elem_parent.outerWidth() / 200;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 9) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 9;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-medium') {
              qty_fit = elem_parent.outerWidth() / 300;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 9) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 9;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-wide') {
              qty_fit = elem_parent.outerWidth() / 450;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 9) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 9;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-x-wide') {
              qty_fit = elem_parent.outerWidth() / 650;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 9) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 9;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            }
          } else if (elem_parent.hasClass('qty-10') && settings.qty_type == 'b-qty') {
            if (settings.width == 'width-x-narrow') {
              qty_fit = elem_parent.outerWidth() / 100;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 5) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 10) {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 10;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-narrow') {
              qty_fit = elem_parent.outerWidth() / 200;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 5) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 10) {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 10;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-medium') {
              qty_fit = elem_parent.outerWidth() / 300;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 5) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 10) {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 10;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-wide') {
              qty_fit = elem_parent.outerWidth() / 450;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 5) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 10) {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 10;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-x-wide') {
              qty_fit = elem_parent.outerWidth() / 650;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 5) {
                qty_row = 3;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 10) {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 10;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            }
          } else if (elem_parent.hasClass('qty-10') && settings.qty_type == 'c-qty') {
            if (settings.width == 'width-x-narrow') {
              qty_fit = elem_parent.outerWidth() / 100;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 3) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 10) {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 10;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-narrow') {
              qty_fit = elem_parent.outerWidth() / 200;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 3) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 10) {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 10;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-medium') {
              qty_fit = elem_parent.outerWidth() / 300;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 3) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 10) {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 10;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-wide') {
              qty_fit = elem_parent.outerWidth() / 450;
              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 3) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 10) {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 10;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-x-wide') {
              qty_fit = elem_parent.outerWidth() / 650;

              if (qty_fit < 3) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 3) {
                qty_row = 2;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 10) {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 10;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            }
          } else if (elem_parent.hasClass('qty-10')) {
            if (settings.width == 'width-x-narrow') {
              qty_fit = elem_parent.outerWidth() / 100;
              if (qty_fit < 5) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 10) {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 10;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-narrow') {
              qty_fit = elem_parent.outerWidth() / 200;
              if (qty_fit < 5) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 10) {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 10;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-medium') {
              qty_fit = elem_parent.outerWidth() / 300;
              if (qty_fit < 5) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 10) {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 10;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-wide') {
              qty_fit = elem_parent.outerWidth() / 450;
              if (qty_fit < 5) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 10) {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 10;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            } else if (settings.width == 'width-x-wide') {
              qty_fit = elem_parent.outerWidth() / 650;
              if (qty_fit < 5) {
                qty_row = 1;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else if (qty_fit < 10) {
                qty_row = 5;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              } else {
                qty_row = 10;
                elem_parent.removeClass(function (index, className) {
                  return (className.match(/(^|\s)qty-top-\S+/g) || []).join(' ');
                }).addClass('qty-top-' + qty_row + '');
              }
            }
          }
          return 1 / qty_row;
        }

        //console.log(elem);
        var elem_width = (qty_feature() * 100);

        $(elem).each(function () {
          $(elem).css('margin', '0');
          $(elem).css('width', elem_width + .0001 + '%');
        });

      }





      number_of_elem = elem_parent.find('.feature').size();

      if (!elem_parent.is('[class*="qty-"]')) {
        if (number_of_elem == 1) {
          elem_parent.addClass('qty-1');
        } else if (number_of_elem == 2) {
          elem_parent.addClass('qty-2');
        } else if (number_of_elem == 3) {
          elem_parent.addClass('qty-3');
        } else if (number_of_elem == 4) {
          elem_parent.addClass('qty-4');
        } else if (number_of_elem == 5) {
          elem_parent.addClass('qty-5');
        } else if (number_of_elem == 6) {
          elem_parent.addClass('qty-6');
        } else if (number_of_elem == 7) {
          elem_parent.addClass('qty-7');
        } else if (number_of_elem == 8) {
          elem_parent.addClass('qty-8');
        } else if (number_of_elem == 9) {
          elem_parent.addClass('qty-9');
        } else if (number_of_elem == 10) {
          elem_parent.addClass('qty-10');
        }
      }
      //console.log(number_of_elem);
      theWindow.on('window:resize', reorganize);
      reorganize();
    })
  }

  ///////////////////////////////////////////////////////////////////////////
  //resize elements 1.0
  ///////////////////////////////////////////////////////////////////////////

  $.fn.qtyResize2 = function (options) {

    var settings = $.extend({
      width: "width-medium",
      qty_type: " "
    }, options) 



    return this.each(function () {
      var elem_parent = $(this);
      
      var elem = elem_parent.children('.feature');
      var elem_min_width = parseInt(elem.css('min-width'), 10);
      var number_of_elem = elem.size();
      var elem_parent_width = elem_parent.width();
      var elem_parent_col = parseInt(elem_parent.css('column-count'), 10);
      var elem_parent_fit = elem_parent_width/elem_min_width;
      elem.last().addClass('qty-last');

      console.log(elem_min_width, elem_parent_width, elem_parent_fit, elem_parent_col)

      function reorganize() {

        var elem_parent_width = elem_parent.width();
        var elem_parent_col = parseInt(elem_parent.css('column-count'), 10);
        var elem_parent_fit = elem_parent_width/elem_min_width;

        function qty_feature(fit,col) {
          var qty_row;
          
          if (fit>=(col)) {
            console.log('fits', 1/col)
            return 1 / col;
          }else{
            
            console.log( Math.round(fit/2))  
            return 1 / Math.round(fit/2);
          }

      
        }

        //console.log(elem);
        var elem_width = (qty_feature(elem_parent_fit, elem_parent_col) * 100);

        $(elem).each(function () {
          $(elem).css('margin', '0');
          $(elem).css('width', elem_width + .0000 + '%');
        });

      }


      //console.log(number_of_elem);
      theWindow.on('window:resize', reorganize);
      reorganize();
    })
  }


})(jQuery); // or even jQuery.noConflict()